<div
  class="delivery-block"
  role="button"
  tabindex="0"
  [style.background-color]="color()"
  [attr.aria-label]="delivery().equipmentLabel + ' · ' + delivery().operatorLabel + ' — ' + delivery().loadedKg + 'kg loaded'"
  [title]="tooltip()"
  (click)="blockClick.emit(delivery())"
  (keydown.enter)="blockClick.emit(delivery())"
  (keydown.space)="blockClick.emit(delivery())"
>
  <span class="block-line1">{{ delivery().equipmentLabel }}</span>
  <span class="block-line2">{{ delivery().loadedKg | number:'1.0-0' }}kg</span>
</div>
